/**
 * useAdminStats hook
 *
 * TanStack Query hook for fetching admin platform statistics from GET /v1/admin/stats.
 * Requires wallet connection and admin access.
 * staleTime matches API KV cache TTL (300s).
 *
 * Story 7.3 — Task 2.2
 */

import { useQuery } from "@tanstack/react-query";

import { adminApi } from "../../lib/api";
import { useWallet } from "../use-wallet";
import { adminKeys } from "./query-keys";

export function useAdminStats() {
	const { isConnected, getAccessToken } = useWallet();

	return useQuery({
		queryKey: adminKeys.stats(),
		queryFn: async () => {
			const token = await getAccessToken();
			if (!token) {
				// eslint-disable-next-line no-restricted-syntax -- TanStack Query requires thrown errors
				throw new Error("No auth token");
			}
			return adminApi.getStats(token);
		},
		enabled: isConnected,
		staleTime: 300_000,
		select: (response) => response.data,
	});
}
